import { color } from '.';

// ------------ General ----------- //

export const border = `1px solid ${color.grey10}`;
export const borderBrandColor = '1px solid #f89e37';
export const borderRadiusSmall = '4px';
export const borderRadius = '8px';
export const borderRadiusLarge = '.5em';

// Animation
export const transitionSpeedNormal = '.2s';
export const transitionSpeedSlower = '.6s';
export const transition = `${transitionSpeedNormal} ease`;
export const transitionSlower = `${transitionSpeedSlower} ease`;

// Heights
export const navbarHeight = '5em';

// Box Shadow
export const cardBoxShadow = '0 2px 4px 0 rgba(0, 0, 0, .06)';
export const boxShadow = '0 4px 24px 0 rgba(0, 0, 0, 0.08)';
export const boxShadowHeavy = '0 4px 24px 0 rgba(0, 0, 0, 0.24)';
export const boxShadowBrand = '0px 16px 24px -10px rgba(32, 146, 209, 0.24)';
